/* eslint-disable react-native/no-color-literals */
import React, { useEffect, useRef } from 'react';
import { View, StyleSheet, TouchableOpacity, Pressable } from 'react-native';
import Image from '@web/components/common/Image';
import { useSelector, useDispatch } from 'react-redux';
import Carousel from '@web-components/common/Carousel';
import { carouselSlide } from '~assets/styles/carouselStyles';
import ModalizeBase from '@web-components/modals/ModalizeBase';
import WithLocalSvg from '@web-components/common/WithLocalSvg';

import Arrow from '@web-components/common/carousels/Arrow';

import { isWeb } from '~global/screens';

const ModalDynamicBanner = (props) => {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);

  const isShow = useSelector((state) => state.modal.dynamicBanner.isShow);
  const banner = useSelector((state) => state.modal.dynamicBanner.data);
  const isMultiplePopUp = banner?.more_info?.popup?.multiple?.is_active;
  const multiplePopUpImage = banner?.more_info?.popup?.multiple?.data;

  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'dynamicBanner' });
  };

  const platform = isWeb ? 'desktop' : 'mobile';
  const settingsImage = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: isWeb ? true : false,

    prevArrow: <Arrow.ArrowLeft customStyle={styles.arrowParentLeftCarousel} />,
    nextArrow: (
      <Arrow.ArrowRight customStyle={styles.arrowParentRightCarousel} />
    ),
  };

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <ModalizeBase
      ref={modalizeRef}
      modalStyle={styles.modal}
      fullScreen={global.isMobileWeb}
      handleStyle={styles.handleStyle}
      onClose={closeModal}>
      <View style={styles.modalStyle}>
        <View style={styles.modalHeader}>
          <Pressable onPress={closeModal}>
            <WithLocalSvg
              key="dismiss"
              style={styles.iconClose}
              asset={require('~assets/img/close-outer-icon.svg')}
              onPress={closeModal}
            />
          </Pressable>
        </View>
        {isMultiplePopUp ? (
          <Carousel {...settingsImage}>
            {(multiplePopUpImage || []).map((item, index) => (
              <View style={styles.imageContainer} key={`imageProduct${index}`}>
                <TouchableOpacity
                  style={[carouselSlide, styles.carouselSlide]}
                  key={`item${index}`}>
                  <Image
                    source={{
                      uri: item?.image[platform],
                    }}
                    style={styles.imageBanner}
                  />
                </TouchableOpacity>
              </View>
            ))}
          </Carousel>
        ) : (
          <View style={styles.imageContainer} key={`imageProduct${4}`}>
            <TouchableOpacity
              style={[carouselSlide, styles.carouselSlide]}
              key={`item${4}`}>
              <Image
                source={{
                  uri: banner?.more_info?.popup?.single.data.image[platform],
                }}
                style={styles.imageBanner}
              />
            </TouchableOpacity>
          </View>
        )}
      </View>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  modalHeader: {
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    borderBottomColor: '#e5e5e5',
  },
  iconClose: {
    right: 0,
    width: isWeb ? 35 : 25,
    height: isWeb ? 35 : 25,
  },
  modal: {
    backgroundColor: 'transparent',
  },
  arrowParentLeftCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
    height: 42,
    width: 42,
    left: 30,
    top: 360,
  },
  arrowParentRightCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
    height: 42,
    width: 41,
    right: 36,
    top: 360,
  },
  imageBanner: {
    maxWidth: isWeb ? 430 : 250,
  },
  carouselSlide: {
    height: 'auto',
    alignItems: 'center',
    paddingTop: 6,
    paddingBottom: 4,
    paddingHorizontal: 15,
  },
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : '#D7CDF5',
    height: 3,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    padding: 20,
    overflow: 'hidden',
    margin: 'auto',
    width: isWeb ? 550 : 300,

    ...(!isWeb
      ? {
          marginBottom: 200,
        }
      : {}),
  },
});

export default ModalDynamicBanner;
